/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetValueForRaster$Params {
  id: string;
  x: number;
  y: number;
}

export function getValueForRaster(http: HttpClient, rootUrl: string, params: GetValueForRaster$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, getValueForRaster.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('x', params.x, {});
    rb.path('y', params.y, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

getValueForRaster.PATH = '/v1/raster/value/raster/{id}/{x}/{y}';
